import { MESSAGE_PLACEHOLDER, NOTE_PLACEHOLDER } from './chat-input-composer.config'
import type { ChatInputMode } from './chat-input-mode.type'

export const getPlaceholder = (mode: ChatInputMode, customPlaceholder?: string): string => {
  if (customPlaceholder) return customPlaceholder
  if (mode === 'note') return NOTE_PLACEHOLDER
  return MESSAGE_PLACEHOLDER
}

export const canSendMessage = (
  value: string,
  attachmentCount: number,
  isDisabled: boolean,
  isLoading: boolean
): boolean => (value.trim().length > 0 || attachmentCount > 0) && !isDisabled && !isLoading
